var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.94238C20 11.5322 17.0899 14.4424 13.5 14.4424C9.91015 14.4424 7 11.5322 7 7.94238C7 4.35253 9.91015 1.44238 13.5 1.44238C17.0899 1.44238 20 4.35253 20 7.94238Z",
    stroke: "#194775",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2285 16.148V16.1481L14.238 16.148C17.0795 16.1211 19.83 17.1488 21.9576 19.0324C24.0705 20.903 25.42 23.4857 25.7496 26.2869C25.7447 26.5731 25.6997 26.7538 25.6186 26.8629C25.5761 26.92 25.389 27.1475 24.5966 27.1475H2.90337C2.15806 27.1475 1.95856 26.9116 1.89539 26.8223C1.79852 26.6854 1.75896 26.4931 1.75139 26.3039C2.20822 23.5008 3.63656 20.9466 5.78772 19.0895C7.95922 17.2148 10.726 16.1724 13.5947 16.148H14.2285Z",
    stroke: "#194775",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.df1c63c5ab39ae4b7be78029b3af2795.svg";
export { ForwardRef as ReactComponent };